import { HttpClient } from '@remodeling/base';
import {
  GetScrapsRequest,
  GetScrapsResponse,
  GetScrapCategoriesRequest,
  GetScrapCategoriesResponse,
  CreateScrapRequest,
  CreateScrapResponse,
  DeleteScrapRequest,
  DeleteScrapResponse,
  GetScrapsCountResponse,
} from '../../model';

export class GetScrapsGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetScrapsRequest) {
    return await this.httpClient.request<GetScrapsResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/common-service/api/v1/commons/scraps`,
      body: req,
    });
  }
}

export class GetScrapCategoriesGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetScrapCategoriesRequest) {
    return await this.httpClient.request<GetScrapCategoriesResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/common-service/api/v1/commons/scraps/categories`,
      body: req,
    });
  }
}

export class CreateScrapGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: CreateScrapRequest) {
    return await this.httpClient.request<CreateScrapResponse>({
      method: 'POST',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/common-service/api/v1/commons/scraps`,
      body: req,
    });
  }
}

export class DeleteScrapGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: DeleteScrapRequest) {
    return await this.httpClient.request<DeleteScrapResponse>({
      method: 'DELETE',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/common-service/api/v1/commons/scraps`,
      body: req,
    });
  }
}

export class GetScrapsCountGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec() {
    return await this.httpClient.request<GetScrapsCountResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/common-service/api/v1/commons/scraps/count`,
    });
  }
}
